module.exports = __webpack_public_path__ + "img/home_icon_xinspect@2x.86893136.png";